import { CALL_API } from 'redux-api-middleware';

import { createRequestTypes } from './utils';
import { buildCurrenciesUrl, buildApiAction } from '../service/oms';

export const NEW = '@@currencies/NEW';
export const UPDATE = '@@currencies/UPDATE';
export const LOADING = '@@currencies/LOADING';
export const FETCH_DATA = createRequestTypes('@@currencies/FETCH_DATA');
export const CHANGE_FILTERS = '@@currencies/CHANGE_FILTERS';

export const FETCH_NAMES = createRequestTypes('@@currencies/FETCH_NAMES');

/**
 *  Fetches list of currencies with columns: ITEM_SECTOR, LONG_NAME
 *  Used to list names of currencies in CurrencyCalculator
 **/
export const requestCurrenciesData = () => ({
    [CALL_API]: {
        endpoint: buildCurrenciesUrl(),
        method: 'GET',
        types: [
            { type: FETCH_NAMES.REQUEST },
            {
                type: FETCH_NAMES.SUCCESS,
                payload: (action, state, res) => {
                    const contentType = res.headers.get('Content-Type');
                    if (contentType && ~contentType.indexOf('json')) {
                        return res.json().then(json =>
                            json.rows.map(row => row.values)
                        );
                    }
                    return null;
                },
            },
            { type: FETCH_NAMES.FAILURE },
        ],
    },
});

/**
 *  Fallback for withTableSubscription when browser does not support websockets
 **/
export function fetchCurrencies(endpoint, params) {
    const meta = { params };

    return buildApiAction({
        endpoint,
        types: [
            { type: FETCH_DATA.REQUEST, meta },
            {
                type: FETCH_DATA.SUCCESS,
                payload: (action, state, response) => {
                    const contentType = response.headers.get('Content-Type');

                    if (contentType && ~contentType.indexOf('json')) {
                        return response.json().then(json => json.rows || []);
                    }

                    return [];
                },
                meta,
            },
            { type: FETCH_DATA.FAILURE, meta },
        ],
    });
}

export function newCurrencies(payload) {
    return { type: NEW, payload };
}

export function updateCurrency(key, data) {
    return { type: UPDATE, key, data };
}

export function loadingCurrencies() {
    return { type: LOADING };
}

export function changeCurrenciesFilters(filters) {
    return { type: CHANGE_FILTERS, filters };
}



/** WEBPACK FOOTER **
 ** /src/shared/actions/currencies.js
 **/